// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60739e9b","239":"63cd8f64","455":"33ac8640","488":"50eb2a24"}[chunkId] + ".chunk.js";
};